import './spoiler.scss';

import { FormattedMessage } from 'react-intl';
import { Spoiler as MantineSpoiler } from '@eliberty/design-system-react/mantine';

interface SpoilerProps {
  maxHeight: number;
  children: React.ReactNode;
}

const Spoiler = ({ maxHeight, children }: SpoilerProps) => {
  return (
    <MantineSpoiler
      maxHeight={maxHeight}
      showLabel={
        <>
          <FormattedMessage id='seeMore' defaultMessage='See more' />{' '}
          <i className='elibertyIcon-chevron-down' />
        </>
      }
      hideLabel={
        <>
          <FormattedMessage id='seeLess' defaultMessage='See less' />{' '}
          <i className='elibertyIcon-chevron-up' />
        </>
      }
    >
      {children}
    </MantineSpoiler>
  );
};

export default Spoiler;
